var map = {
	"./android-chrome-192x192": 20,
	"./android-chrome-192x192.png": 20,
	"./android-chrome-512x512": 21,
	"./android-chrome-512x512.png": 21,
	"./apple-touch-icon": 22,
	"./apple-touch-icon.png": 22,
	"./favicon-16x16": 23,
	"./favicon-16x16.png": 23,
	"./favicon-32x32": 24,
	"./favicon-32x32.png": 24,
	"./favicon.ico": 479,
	"./mstile-144x144": 25,
	"./mstile-144x144.png": 25,
	"./mstile-150x150": 26,
	"./mstile-150x150.png": 26,
	"./mstile-310x310": 27,
	"./mstile-310x310.png": 27,
	"./mstile-70x70": 28,
	"./mstile-70x70.png": 28,
	"./safari-pinned-tab": 29,
	"./safari-pinned-tab.svg": 29
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 478;